import { common_process_type, delete_db_type, get_db_type, key_func_type, response_type, response_type_internal, set_db_type } from '../interfaces';

// 注意事項：
// 1. 只能用 ES6 以下語法 (不能使用 async, await, spread operator(...))

declare const get_db: get_db_type;
declare const set_db: set_db_type;
declare const delete_db: delete_db_type;
declare const self: { db_version: { [key: string]: number }; db_disabled: boolean };
declare const common_process: common_process_type;
declare const post_process: key_func_type['post_process'] | key_func_type['post_process'][];
declare const close: () => void;

export default function db_request(_args: any): void {
  try {
    // @ts-ignore
    importScripts('core-js/es/promise');
  } catch (err) {}

  // 宣告接收到訊息時要做的事
  onmessage = (event: MessageEvent): void => {
    // ███╗   ███╗ █████╗ ██╗███╗   ██╗
    // ████╗ ████║██╔══██╗██║████╗  ██║
    // ██╔████╔██║███████║██║██╔██╗ ██║
    // ██║╚██╔╝██║██╔══██║██║██║╚██╗██║
    // ██║ ╚═╝ ██║██║  ██║██║██║ ╚████║
    // ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
    // 主             程             式

    const args: [number, string, any | undefined] = JSON.parse(event.data);
    self.db_version = {};
    self.db_disabled = false;
    // get_db(`${/* db_name */ args[1]}_version`, 'version')
    // .then(({ response }: get_db_response_type) => {
    // (response as string[] | undefined)?.[0] && (self.db_version[args[1]] = Number((response as string[])[0]));

    if (/* db_name */ args[1]) {
      [
        () => {
          get_db(/* db_name */ args[1])
            .then((response: unknown | unknown[] | undefined) => {
              (response as any).kind = args[1][0];
              new Promise((resolve) => {
                // 如果 db_name 是好幾個的話，reponse 應跑迴圈處理
                if (Array.isArray(/* db_name */ args[1]))
                  response = (response as response_type[] | undefined)?.map((response_each: response_type) => common_process(response_each, args[2]));
                else response = response && common_process(response as response_type, args[2]);

                // 處理後將結果回傳給主線程
                if (post_process) {
                  (Array.isArray(post_process)
                    ? Promise.all(
                        post_process.map(
                          (post_process_each, index: number) =>
                            new Promise((resolve_2: (value?: unknown) => void) => {
                              post_process_each?.({
                                response: (response as (response_type_internal | undefined)[])?.[index],
                                resolve: resolve_2
                              }) || resolve_2((response as (response_type_internal | undefined)[])?.[index]);
                            })
                        )
                      )
                    : new Promise((resolve_2: (value?: unknown) => void) => {
                        post_process({
                          response: response as response_type,
                          resolve: resolve_2
                        });
                      })
                  )
                    .then((result: unknown | unknown[] | undefined) => {
                      resolve(result);
                    })
                    .catch((err: any) => {
                      console.error(err);
                      resolve(response);
                    });
                }
                // 不處理，將結果回傳給主線程
                else resolve(response);
              }).then((result: unknown | unknown[] | undefined) => {
                // @ts-ignore
                postMessage(
                  JSON.stringify(
                    Array.isArray(result as response_type)
                      ? (result as (response_type_internal | undefined)[])?.map(
                          (result_each: response_type_internal | undefined) => result_each?.items || result_each
                        )
                      : result
                  )
                );
                setTimeout(() => {
                  close();
                }, 0); // 結束 Worker
              });
            })
            .catch((err) => {
              // @ts-ignore
              postMessage([]);
              console.error(err);
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            });
        },
        () => {
          set_db(/* db_name */ args[1], /* value */ args[2])
            .then(() => {
              // @ts-ignore
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            })
            .catch((err) => {
              // @ts-ignore
              console.error(err);
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            });
        },
        () => {
          delete_db(/* db_name */ args[1])
            .then(() => {
              // @ts-ignore
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            })
            .catch((err) => {
              // @ts-ignore
              console.error(err);
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            });
        }
      ][args[0]]();
    }
    // })
    // .catch(() => {
    //   // @ts-ignore
    //   postMessage([]);
    // });
  };
}
